import script from "./ChgDistributionView.vue?vue&type=script&setup=true&lang=js"
export * from "./ChgDistributionView.vue?vue&type=script&setup=true&lang=js"

import "./ChgDistributionView.vue?vue&type=style&index=0&id=0d5a8b38&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d5a8b38"]])

export default __exports__